import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DrawerContextType {
    open: boolean;
    toggleDrawer: () => void;
    setOpen: (open: boolean) => void;
}

const DrawerContext = createContext<DrawerContextType | undefined>(undefined);

export const DrawerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [open, setOpen] = useState(true);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    return (
        <DrawerContext.Provider value={{ open, toggleDrawer, setOpen }}>
            {children}
        </DrawerContext.Provider>
    );
};

export const useDrawer = (): DrawerContextType => {
    const context = useContext(DrawerContext);
    if (context === undefined) {
        throw new Error('useDrawer must be used within a DrawerProvider');
    }
    return context;
};